'use strict';
Object.defineProperty(exports, Symbol.toStringTag, {
    value: 'Module'
});
var flattenDeep = require('./flattenDeep.js');
function flatMapDeep(arr, iteratee) {
    return flattenDeep.flattenDeep(arr.map(function(item) {
        return iteratee(item);
    }));
}
exports.flatMapDeep = flatMapDeep;
